import styled from 'styled-components';

const StyledIconWrapper = styled.div`
  width: 24px;
  text-align: ${(props) => (props.iconOnLeft ? 'left' : 'right')};
`;

export default StyledIconWrapper;
